import LocalizedStrings from 'localized-strings';

interface InternationalTransferAdditionalInformationLocale {
  submit: string;
  title: string;
}

export default new LocalizedStrings<InternationalTransferAdditionalInformationLocale>(
  {
    en: {
      submit: 'Next',
      title: 'Add further information',
    },
    fr: {
      submit: 'Suivant',
      title: 'Informations complémentaires',
    },
  } as const,
);
